import { Injectable } from '@angular/core';
import { LoadingController, AlertController, ToastController, MenuController } from '../../node_modules/@ionic/angular';
import { Router } from '../../node_modules/@angular/router';
import { MydbService } from './mydb.service';
// import { MydbProvider } from './mydb.service';
// import moment from 'moment';
import * as CryptoJS from 'crypto-js';

@Injectable({
  providedIn: 'root'
})
export class GenericService {
  backButtonSubscription;
  app_version: string;
  loadingPopup = null;
  buttonTextList = {
    OK: 'Okay',
    Cancel: 'Cancel',
    Sure: 'Sure',
    Dismiss: 'Dismiss'
  };
  browser: any;
  requestTypeList = {
    GET: 1,
    POST: 2
  };
  requestType = Object.freeze(Object.assign({}, this.requestTypeList));
  loaderMessagesList = {
    fetch: 'Please wait while we populate the list...',
    authenticate: 'Authenticating.. Please wait..'
  };


  constructor(private loadingController: LoadingController, private alertController: AlertController,
    private toastController: ToastController, private router: Router, private menuCtrl: MenuController, private mydb: MydbService) { }

  // getFormattedDate(date: Date, requiredFormat: string, currentFormat?) {
  //   if (currentFormat) {
  //     return moment(date, currentFormat).format(requiredFormat).toString();
  //   } else {
  //     return moment(date).format(requiredFormat).toString();
  //   }
  // }

  async presentAlert(header, message, subHeader?) {
    const alert = await this.alertController.create({
      header: header,
      subHeader: subHeader,
      message: message,
      buttons: ['OK']
    });
    await alert.present();
  }

  async presentToast(message) {
    const toast = await this.toastController.create({
      message: message,
      duration: 2000
    });
    toast.present();
  }



  async hideLoader() {
    const loading = await this.loadingController.getTop();
    loading.dismiss();
  }

  async presentAlertMultipleButtons() {
    const alert = await this.alertController.create({
      header: 'Thanks!',
      message: 'We would like to serve you better. Please visit http://www.heromotocorp.com',
      buttons: ['Visit', 'No thanks']
    });

    await alert.present();
  }

  async showAlertUponSuccess(title: string, message: string, buttonOk?: string) {
    return new Promise(async (resolve) => {
      let alert = await this.alertController.create({
        header: title, //'Confirm purchase',
        message: message,//'Do you want to buy this book?',
        backdropDismiss: false,
        cssClass: 'my-custom-class',
        buttons: [
          {
            text: buttonOk || 'Ok',
            handler: _ => resolve(true)
          }
        ]
      });
      await alert.present();
    })
  }

  async showAlertUponSuccessNon(title: string, message: string, buttonOk?: string, buttonCancel?: string) {
    return new Promise(async (resolve) => {
      let alert = await this.alertController.create({
        header: title, //'Confirm purchase',
        message: message,//'Do you want to buy this book?',
        cssClass: 'my-custom-class',
        buttons: [
          {
            text: buttonOk || 'Ok',
            handler: _ => resolve(true)
          },
          {
            text: buttonCancel || 'Cancel'
          }
        ]
      });
      await alert.present();
    })
  }

  async confirmExitApp(headerText?) {
    const alert = await this.alertController.create({
      header: headerText ? headerText : 'Exit?',
      message: 'Confirm exit?',
      buttons: [
        {
          text: 'Yes',
          handler: () => { //takes the data 
            navigator['app'].exitApp();
          }
        },
        {
          text: 'No',
          handler: () => {
         
          }
        }
      ],
      backdropDismiss: true
    });
    await alert.present();
  }

  async presentExitAlert(headerText?) {
    const alert = await this.alertController.create({
      header: headerText ? headerText : 'Server Error!',
      message: 'Confirm sign out?',
      buttons: [
        {
          text: 'Yes',
          handler: () => { //takes the data 
            this.menuCtrl.enable(false);
            this.mydb.clearStorage().then(() => {
              this.router.navigateByUrl('home');
            })
          }
        },
        {
          text: 'No',
          handler: () => {
            
          }
        }
      ],
      backdropDismiss: true
    });
    await alert.present();
  }
  encrypt(data) {
    if(data==null)
    {
          this.router.navigateByUrl('/login');
          return;
          
    }
    var key = "qwertyuiopasdfg";
    return CryptoJS.AES.encrypt(JSON.stringify(data), key).toString();
  }
  
  decrypt(data) {
    if(data==null)
    {
          this.router.navigateByUrl('/login')
          return;
          
    }

    var key = "qwertyuiopasdfg";
    let bytes = CryptoJS.AES.decrypt(data, key);
    return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
  }

 

 
}
